import { createSlice } from '@reduxjs/toolkit'

// Slice
const slice = createSlice({
  name: 'dashboardCards',
  initialState: {
    dashboardCards: [],
  },
  reducers: {
    setDashboardCards: (state, { payload }) => {
      state.dashboardCards = payload
    },
  },
})

export const { setDashboardCards } = slice.actions

export default slice.reducer
